import React, { useState, useEffect } from "react";
import LoadingComponent from "commons/loading/Loading.component";
import { Link } from "react-router-dom";
import { formatTimeAgo } from "helpers/Datetime.helper";
import { getLanguageValue } from "locales/i18n";
import { PAGE_TYPE } from "enums";
import { getImageUrl } from "helpers/Image.helper";

const CastingMessage = () => {
    const [isOnNetworking, setIsOnNetworking] = useState(false);
    const [requestList, setRequestList] = useState<Array<any>>([]);
    const [roomList, setRoomList] = useState<Array<any>>([]);

    // 더미 데이터
    const dummyRequestList = [
        {
            id: 1,
            userStudentInfo: {
                studentInfo: {
                    nameKo: "김민수",
                    nameEn: "Kim Minsoo",
                    profileImageInfo: {
                        subUrl: "/imgs/dummy/girls/girl-1.jpg",
                        width: 200,
                        height: 200
                    }
                },
                countryInfo: {
                    code: "KR"
                }
            },
            createdAt: "2024-03-15T10:30:00Z"
        },
        {
            id: 2,
            userStudentInfo: {
                studentInfo: {
                    nameKo: "박지영",
                    nameEn: "Park Jiyoung",
                    profileImageInfo: {
                        subUrl: "/imgs/dummy/girls/girl-2.jpg",
                        width: 200,
                        height: 200
                    }
                },
                countryInfo: {
                    code: "KR"
                }
            },
            createdAt: "2024-03-14T15:45:00Z"
        },
        {
            id: 3,
            userStudentInfo: {
                studentInfo: {
                    nameKo: "이준호",
                    nameEn: "Lee Junho",
                    profileImageInfo: {
                        subUrl: "/imgs/dummy/boys/boy-1.jpg",
                        width: 200,
                        height: 200
                    }
                },
                countryInfo: {
                    code: "KR"
                }
            },
            createdAt: "2024-03-13T09:20:00Z"
        }
    ];

    const dummyRoomList = [
        {
            channelId: "chat_001",
            userStudentInfo: {
                studentInfo: {
                    nameKo: "김민수",
                    nameEn: "Kim Minsoo",
                    profileImageInfo: {
                        subUrl: "/imgs/dummy/girls/girl-1.jpg",
                        width: 200,
                        height: 200
                    }
                },
                countryInfo: {
                    code: "KR"
                }
            },
            lastMessage: "안녕하세요! 학원에 대해 더 자세히 알고 싶습니다.",
            lastMessageAt: "2024-03-15T14:30:00Z",
            isReadSchool: false
        },
        {
            channelId: "chat_002",
            userStudentInfo: {
                studentInfo: {
                    nameKo: "박지영",
                    nameEn: "Park Jiyoung",
                    profileImageInfo: {
                        subUrl: "/imgs/dummy/girls/girl-2.jpg",
                        width: 200,
                        height: 200
                    }
                },
                countryInfo: {
                    code: "KR"
                }
            },
            lastMessage: "수업 시간표를 보내주실 수 있나요?",
            lastMessageAt: "2024-03-15T12:15:00Z",
            isReadSchool: true
        },
        {
            channelId: "chat_003",
            userStudentInfo: {
                studentInfo: {
                    nameKo: "이준호",
                    nameEn: "Lee Junho",
                    profileImageInfo: {
                        subUrl: "/imgs/dummy/boys/boy-1.jpg",
                        width: 200,
                        height: 200
                    }
                },
                countryInfo: {
                    code: "KR"
                }
            },
            lastMessage: "오디션 준비는 어떻게 하면 될까요?",
            lastMessageAt: "2024-03-15T11:00:00Z",
            isReadSchool: false
        }
    ];

    useEffect(() => {
        // 더미 데이터 로딩 시뮬레이션
        setIsOnNetworking(true);
        setTimeout(() => {
            setRequestList(dummyRequestList);
            setRoomList(dummyRoomList);
            setIsOnNetworking(false);
        }, 1000);
    }, []);

    const handleRequestClick = (requestId: number) => {
        console.log('Request clicked:', requestId);
        // 여기에 요청 처리 로직 추가
    };

    return (
        <main className="bg-gray-50 min-h-screen">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6">
                {/* 대화 요청 목록 */}
                <div className="mb-8">
                    <h2 className="text-xl font-bold text-gray-900 mb-4">
                        {getLanguageValue(PAGE_TYPE.SCHOOL, "message.txtRequestTitle")}
                    </h2>
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
                        {isOnNetworking && <LoadingComponent />}
                        {!isOnNetworking &&
                            <div className="overflow-x-auto lg:overflow-visible">
                                <div className="flex gap-4 lg:flex-wrap">
                                    {requestList?.map((item: any) => (
                                        <div
                                            onClick={() => handleRequestClick(item.id)}
                                            key={item.id}
                                            className="w-[100px] sm:w-[125px] lg:w-[150px] flex-shrink-0 cursor-pointer hover:scale-105 transition-transform">
                                            <div className="flex flex-col items-center">
                                                <div className="rounded-full overflow-hidden w-14 h-14 sm:w-16 sm:h-16 flex-shrink-0 border-2 border-gray-100">
                                                    <img
                                                        src={getImageUrl(item?.userStudentInfo?.studentInfo?.profileImageInfo)}
                                                        alt={item?.userStudentInfo?.studentInfo?.nameKo}
                                                        className="w-full h-full object-cover"
                                                    />
                                                </div>
                                                <div className="mt-2 text-center w-full">
                                                    <p className="text-gray-900 text-xs truncate px-2">
                                                        {item?.userStudentInfo?.studentInfo?.nameKo}
                                                    </p>
                                                    <p className="text-gray-500 text-xs truncate px-2">
                                                        {formatTimeAgo(item.createdAt)}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    {requestList?.length === 0 &&
                                        <div className="text-center py-4 text-gray-500">
                                            {getLanguageValue(PAGE_TYPE.SCHOOL, "message.txtEmptyRequest")}
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </div>

                {/* 대화방 목록 */}
                <div>
                    <h2 className="text-xl font-bold text-gray-900 mb-4">
                        {getLanguageValue(PAGE_TYPE.SCHOOL, "message.txtChatTitle")}
                    </h2>
                    {isOnNetworking && <LoadingComponent />}
                    {!isOnNetworking &&
                        (roomList?.length > 0 ? (
                            <div className="space-y-4">
                                {roomList.map((room: any, idx: number) => (
                                    <Link
                                        key={idx}
                                        to={`/school/casting/message/${room.channelId}/chat`}
                                        className="block bg-white p-4 rounded-xl shadow-sm hover:shadow-md transition-shadow">
                                        <div className="flex items-start gap-4 p-2 hover:bg-gray-50 transition-colors rounded-lg">
                                            {/* 왼쪽 프로필 이미지 */}
                                            <div className="w-14 h-14 flex-shrink-0 rounded-full overflow-hidden border-2 border-gray-100">
                                                <img
                                                    src={getImageUrl(room?.userStudentInfo?.studentInfo?.profileImageInfo)}
                                                    alt={room?.userStudentInfo?.studentInfo?.nameKo}
                                                    className="w-full h-full object-cover"
                                                />
                                            </div>

                                            {/* 가운데 내용 */}
                                            <div className="flex-1 min-w-0">
                                                <p className="text-sm font-medium text-gray-600 mb-1 truncate">
                                                    {room?.userStudentInfo?.studentInfo?.nameKo}
                                                </p>
                                                <h3 className="text-base text-gray-900 leading-snug truncate">
                                                    {room.lastMessage}
                                                </h3>
                                                <p className="text-xs text-gray-400 mt-1.5 flex items-center gap-1">
                                                    <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                    </svg>
                                                    {room.lastMessageAt ? formatTimeAgo(room.lastMessageAt) : ""}
                                                </p>
                                            </div>

                                            {/* 오른쪽 읽음여부 */}
                                            <div className="w-8 flex-shrink-0 flex items-start justify-end pt-1">
                                                {!room.isReadSchool && (
                                                    <span className="inline-flex items-center justify-center w-3 h-3 bg-[#CF3688] text-white text-xs rounded-full animate-pulse"></span>
                                                )}
                                            </div>
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        ) : (
                            <div className="text-center py-8 text-gray-500">
                                {getLanguageValue(PAGE_TYPE.SCHOOL, "message.txtEmptyChat")}
                            </div>
                        ))}
                </div>
            </div>
        </main>
    );
};

export default CastingMessage;
